@app.controller 'AdminNavController', ($rootScope) ->
  @menuItemsTemplate = "/assets/templates/admin/adminNav/adminNavItems.html"

  $rootScope.$on '$stateChangeSuccess', =>
    @showMenu = false

  this
